import React, { useEffect, useState } from "react";
import { CATEGORY, Investers } from "../../../api/endpoints";
import Api_Instance from "../../../api/Api_Instance";
import { INVESTMENT_RANGE } from "../../../utils/Utils";
import toast from "react-hot-toast";
import { debounce } from "../../../common/debounce/debounce.js";
import CountriesApi from "../../../common/countriesapi/CountriesApi";
import { NavLink } from "react-router-dom";
import { emojiRegex, formatField, pinCodeRegex } from "../../../CommonExport.js";
import { useSelector } from "react-redux";
function Invester() {
  const api = Api_Instance.unAuth();
  const { useCountries, States, Ctiy } = CountriesApi;
  const [errors, setErrors] = useState({});
  const [categorydata, setCategoryData] = useState([]);
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const advertisementData = useSelector((state) => state?.auth?.advertisement_data)
  const { citydata } = Ctiy(countrydata.stateid);
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    mobile_number: "",
    email: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    investment: "",
    category: "",
    direct_lead: true,
    role: "investor",
  });

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormValues({
      ...formValues,
      [name]: name === "terms_conditions" ? checked : value,
    });
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formValues,
      [name]: value,
    });
    setErrors(validationErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formValues);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        const res = await api("POST", Investers.POST_INVESTER, formValues);
        if (res.status) {
          toast.success(res.data.message || "Successfully Created");
          setFormValues({
            first_name: "",
            last_name: "",
            mobile_number: "",
            email: "",
            address: "",
            country: "",
            state: "",
            city: "",
            pincode: "",
            investment: "",
            category: "",
            direct_lead: true,
            terms_conditions: false,
            role: "investor",
          });
          setCountrydata({
            countryid: "",
            stateid: "",
            cityid: "",
          });
          setErrors({});
        }
      } catch (error) {
        toast.error(error?.response?.data?.errors?.email[0] || "Invalid data");
      }
    }
  };

  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "first_name",
      "last_name",
      "mobile_number",
      "email",
      "address",
      "country",
      "state",
      "city",
      "pincode",
      "investment",
      "category",
    ];

    requiredFields.forEach((field) => {
      const value = values[field];

      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        if (field != "state" && field != "city") {
          errors[field] = `${formatField(field)} is required`;
        } else if (field == "state" && statedata.length > 0) {
          errors[field] = `${formatField(field)} is required`;
        } else if (field == "city" && citydata.length > 0) {
          errors[field] = `${formatField(field)} is required`;
        }
      }
    });


    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const multipleDomainsPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+\.[^\s@]+$/;
    if (values.email) {
      const trimmedEmail = values.email.trim();
      if (/^\s/.test(values.email) || !emailPattern.test(trimmedEmail) || multipleDomainsPattern.test(trimmedEmail)) {
        errors.email = "Email address is invalid";
      }
    }
    if (values.first_name) {
      if (!/^[A-Za-z\s]+$/.test(values.first_name)) {
        errors.first_name = "First name should only contain letters and spaces";
      } else if (values.first_name.length < 2) {
        errors.first_name = "First name must be at least 2 characters";
      } else if (values.first_name.length > 20) {
        errors.first_name = "First name must be at most 20 characters";
      } else if (emojiRegex.test(values.first_name)) {
        errors.first_name = "First name should not contain emojis";
      }
    }
    if (values.last_name) {
      if (!/^[A-Za-z\s]+$/.test(values.last_name)) {
        errors.last_name = "Last name should only contain letters and spaces";
      } else if (values.last_name.length < 2) {
        errors.last_name = "Last name must be at least 2 characters";
      } else if (values.last_name.length > 20) {
        errors.last_name = "Last name must be at most 20 characters";
      } else if (emojiRegex.test(values.last_name)) {
        errors.last_name = "Last name should not contain emojis";
      }
    }
    if (values.pincode) {
      if (!pinCodeRegex.test(values.pincode)) {
        errors.pincode =
          "Pincode must be exactly 6 digits and contain no letters, spaces, or special characters.";
      }
      if (emojiRegex.test(values.pincode)) {
        errors.pincode = "Pincode should not contain emojis";
      }
    }
    if (values.establish_year && !/^\d{4}$/.test(values.establish_year)) {
      errors.establish_year = "Established Year is invalid";
    }

    if (values.franchise_start && !/^\d{4}$/.test(values.franchise_start)) {
      errors.franchise_start = "Franchisee Started is invalid";
    }

    const mobileNumberRegex = /^[6-9]\d{9}$/;
    if (values.mobile_number) {
      if (!mobileNumberRegex.test(values.mobile_number)) {
        errors.mobile_number =
          "Mobile number must be exactly 10 digits long, start with 6, 7, 8, or 9, and contain no letters, special characters, or spaces.";
      }
    } else {
      errors.mobile_number = "Mobile number is required.";
    }

    if (values.address) {
      const addressLength = values.address.trim().length;
      if (emojiRegex.test(values.address)) {
        errors.address = "Address should not contain emojis";
      }
      if (addressLength > 150) {
        errors.address =
          "Address must not exceed 150 characters.";
      }
    } else {
      errors.address = "Address is required.";
    }

    if (!values?.terms_conditions) {
      errors.terms_conditions = "Please agree to the Terms & Conditions."
    }
    return errors;
  };
  const cateGoryApi = async () => {
    try {
      const res = await api("GET", CATEGORY.GET_CATEGORY);
      setCategoryData(res?.data?.data);
    } catch (error) { }
  };


  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };

  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormValues((prevValues) => ({
      ...prevValues,
      state: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  useEffect(() => {
    cateGoryApi();
  }, [formValues.user]);
  useEffect(() => {
  }, [formValues.category]);
  return (
    <div className="bg-[#ffffff] pb-8 xl:px-0 lg:px-0 md:px-4 px-2">
      {/* <div className="bg-subheader_background w-full h-24 flex items-center justify-center">
        <p className="text-2xl font-lg text-text_color">
          Investor Registration
        </p>
      </div> */}
      <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mt-8">
        <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-start justify-between mx-auto">
          <div className="flex-[0_0_75%]">
            <div className="bg-[#fafafa]  xl:p-8 lg:p-8 md:p-3 px-3 py-3 rounded-lg w-full mx-auto">
              <form onSubmit={handleSubmit}>

                <div className="xl:mb-8 lg:mb-8 md:mb-8 mb-3">
                  <h3 className="text-2xl font-lg font-semibold mb-3 border-b-1">Basic Details</h3>
                  <div className="flex flex-col md:flex-row xl:gap-4 lg:gap-4 md:gap-4 gap-2">
                    <div className="flex-1">
                      <label htmlFor="FirstName" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                        First Name<span className="text-star_color">*</span>
                      </label>
                      <div className="relative">
                        <div>
                          {/* <FaUser className="absolute top-[9px] bottom-[0] left-[10px]" /> */}
                        </div>
                        <input
                          type="text"
                          id="FirstName"
                          name="first_name"
                          value={formValues.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter First Name"
                          className="p-2 border border-gray-300 rounded w-full"
                          maxLength="25"
                        />
                      </div>
                      {errors.first_name && (
                        <p className="text-star_color text-sm">{errors.first_name}</p>
                      )}
                    </div>
                    <div className="flex-1">
                      <label htmlFor="LastName" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                        Last Name <span className="text-star_color">*</span>
                      </label>
                      <input
                        type="text"
                        id="LastName"
                        name="last_name"
                        value={formValues.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Last Name"
                        maxLength="15"
                        className="p-2 border border-gray-300 rounded w-full"
                      />

                      {errors.last_name && (
                        <p className="text-star_color text-sm">{errors.last_name}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="xl:grid lg:grid md:grid block grid-cols-1 grid-cols-2 gap-2">
                  <div className="xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="Mobile" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm" font-semibold>
                      Mobile <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="Mobile"
                      name="mobile_number"
                      value={formValues.mobile_number}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Mobile"
                      className="p-2 border border-gray-300 rounded w-full"
                    />

                    {errors.mobile_number && (
                      <p className="text-star_color text-sm">
                        {errors.mobile_number}
                      </p>
                    )}
                  </div>
                  <div className="xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="Email" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      Email <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="Email"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Email"
                      className="p-2 border border-gray-300 rounded w-full"
                    />

                    {errors.email && (
                      <p className="text-star_color text-sm">{errors.email}</p>
                    )}
                  </div>
                  <div className="col-span-2 xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="Address" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      Address<span className="text-star_color">*</span>
                    </label>
                    <textarea type="text"
                      id="Address"
                      name="address"
                      value={formValues.address}
                      onChange={handleChange}
                      onBlur={handleBlur} placeholder="Enter address" className="p-2 border border-gray-300 rounded w-full h-[100px] overflow-auto">

                    </textarea>
                    {errors.address && (
                      <p className="text-star_color text-sm">{errors.address}</p>
                    )}
                  </div>
                  <div className="relative xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="country" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      Country <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="country"
                      name="country"
                      value={formValues.country}
                      onChange={handleCountryChange}
                      onBlur={handleBlur}
                      className="p-2 border border-gray-300 rounded w-full xl:text-base lg:text-base md:text-base text-sm font-semibold"
                    >
                      <option value="" disabled>
                        Country
                      </option>
                      {countries?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.country && (
                      <p className="text-star_color text-sm">{errors.country}</p>
                    )}
                  </div>
                  <div className="xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="state" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      state <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="state"
                      name="state"
                      value={formValues.state}
                      onChange={handleStateChange}
                      onBlur={handleBlur}
                      className="p-2 border border-gray-300 rounded w-full xl:text-base lg:text-base md:text-base text-sm font-semibold"
                    >
                      <option value="" disabled>
                        State
                      </option>
                      {statedata?.map((item) => (
                        <option value={item.name} data-id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>

                    {errors.state && (
                      <p className="text-star_color text-sm">{errors.state}</p>
                    )}
                  </div>
                  <div className="relative xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="city" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      City<span className="text-star_color">*</span>
                    </label>
                    <select
                      id="city"
                      name="city"
                      value={formValues.city}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="p-2 border border-gray-300 rounded w-full xl:text-base lg:text-base md:text-base text-sm font-semibold"
                    >
                      <option value="" disabled>
                        City
                      </option>
                      {citydata?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>

                    {errors.city && (
                      <p className="text-star_color text-sm">{errors.city}</p>
                    )}
                  </div>
                  <div className="xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="pincode" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      pincode<span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="pincode"
                      name="pincode"
                      value={formValues.pincode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Pincode"
                      className="p-2 border border-gray-300 rounded w-full xl:text-base lg:text-base md:text-base text-sm font-semibold"
                    />
                    {errors.pincode && (
                      <p className="text-star_color text-sm">{errors.pincode}</p>
                    )}
                  </div>

                  <div className="relative xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="investment" className="mb-1 block xl:text-base lg:text-base md:text-base text-sm font-semibold">
                      Investment Range<span className="text-star_color">*</span>
                    </label>
                    <select
                      id="investment"
                      name="investment"
                      value={formValues.investment}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className="p-2 border border-gray-300 rounded w-full xl:text-base lg:text-base md:text-base text-sm font-semibold"
                    >
                      <option value="" disabled>
                        Investment
                      </option>
                      {INVESTMENT_RANGE?.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>

                    {errors.investment && (
                      <p className="text-star_color text-sm">{errors.investment}</p>
                    )}
                  </div>
                  <div className="relative xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                    <label htmlFor="category" className="mb-1 block xl:text-base lg:text-base  md:text-base text-sm font-semibold">
                      Select Category<span className="text-star_color">*</span>
                    </label>
                    <select
                      id="category"
                      name="category"
                      value={formValues.category}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      className="p-2 border border-gray-300 rounded w-full xl:text-base lg:text-base md:text-base text-sm font-semibold"
                    >
                      <option value="" disabled>
                        Category
                      </option>
                      {categorydata?.map((item) => (
                        <option value={item?.id}>{item?.name}</option>
                      ))}
                    </select>
                    {errors.category && (
                      <p className="text-star_color text-sm">{errors.category}</p>
                    )}
                  </div>
                  {/* <div className="relative xl:mb-0 lg:mb-0 md:mb-0 mb-3">
                  <label htmlFor="sub_category" className="mb-1 block xl:text-base  lg:text-base  md:text-base   text-sm">
                    Sub Category<span className="text-star_color">*</span>
                  </label>
                  <select
                    id="sub_category"
                    name="sub_category"
                    value={formValues.sub_category}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300  rounded w-full xl:text-base lg:text-base md:text-base text-sm"
                  >
                    <option value="" >
                      Category
                    </option>
                    {subcategory?.map((item) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}
                  </select>

                  {errors.sub_category && (
                    <p className="text-star_color text-sm">{errors.sub_category}</p>
                  )}
                </div> */}
                </div>
                <div className="mt-4">
                  <div className="flex items-start">
                    <input
                      type="checkbox"
                      id="agreementNo"
                      name="terms_conditions"
                      value="no"
                      onChange={handleChange}
                    />
                    <label htmlFor="agreementNo" className="ml-4 font-sm text-sm">
                      I/We have carefully read and agree to the{" "}
                      <NavLink to="/terms">
                        <span className="text-primaryColor" >Terms & Conditions.</span>
                      </NavLink>
                    </label>
                  </div>
                  {errors.terms_conditions && (
                    <p className="text-star_color text-sm">{errors.terms_conditions}</p>
                  )}
                </div>
                <div className="flex justify-center items-center">
                  <button
                    type="submit"
                    className="bg-primaryColor text-white p-2 rounded mt-4 w-24"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="flex-[0_0_20%] bg-[#fafafa] rounded-lg w-full mx-auto p-1">

            <div className="bg-white p-2 mb-2 max-w-[320px]">
              {advertisementData
                ?.filter((item) => ['SideBanner1'].includes(item?.category))
                ?.map((filteredItem) => (
                  <a
                    key={filteredItem?.index}
                    href={filteredItem?.url}
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="" />
                  </a>
                ))}
            </div>
            <div className="bg-white p-2 mb-2 max-w-[320px]">
              {advertisementData
                ?.filter((item) => ['SideBanner2'].includes(item?.category))
                ?.map((filteredItem) => (
                  <a
                    key={filteredItem?.index}
                    href={filteredItem?.url}
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="w-full" />
                  </a>
                ))}
            </div>
            <div className="bg-white p-2 mb-2 max-w-[320px]">
              {advertisementData
                ?.filter((item) => ['SideBanner3'].includes(item?.category))
                ?.map((filteredItem) => (
                  <a
                    key={filteredItem?.index}
                    href={filteredItem?.url}
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="" />
                  </a>
                ))}
            </div>
            {/* <div className="bg-[#fafafa] p-3 rounded-lg w-full mx-auto mt-4 border">
            <div className="max-w-[312px]">
              <img src="../../../../img/Artboard 4.jpg"></img>
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invester;
